import { render, staticRenderFns } from "./DwgViewer.vue?vue&type=template&id=6b38d9d2&scoped=true"
import script from "./DwgViewer.vue?vue&type=script&lang=js"
export * from "./DwgViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b38d9d2",
  null
  
)

export default component.exports